import React from "react"
import { FxButton } from "../button/FxButton";
import { ExportHelper } from "../helpers";

export const ExportFile = (props: any) => {
  const {id} = props;

  let fileFormat = [
    { code: 'csv', text: 'CSV' },
    { code: 'xlsx', text: 'XLSX' }
  ]

  const exportFile = (fileName: any, file: any) => {
    if (!props.onExport) {
      alert(props.onExportRequiredAlertMsg);
      return;
    }
    const items: any = props.onExport();
    if (file == 'csv') {
      exportToCSV(items, fileName);
    } else if (file == 'xlsx') {
      exportToXLSX(items, fileName);
    }

    props.cancel();
  }

  const exportToCSV = (items: any, fileName: any) => {
    ExportHelper.exportToCSV(items, fileName);
  };

  const exportToXLSX = (items: any, fileName: any) => {
    ExportHelper.exportToExcel(items, fileName);
  };

  return (
    <div id={id} className="exportFileRoot p-2">
      <b>Export</b>
      <div className="pt-2">
        {fileFormat && fileFormat.map((file: any, index: number) => (
          <span key={index} className="m-left-2">
            {index + 1})
            <FxButton label={file.text} variant="text" onClick={() => exportFile(props.fileName || 'download', file.code)} />
          </span>
        ))
        }
      </div>
    </div>
  )
};